import React from 'react'
import { connect } from 'react-redux'
import { Col } from 'react-bootstrap'
import CardValores from './CardValores'

function ValoresEmbarque (props) {
  const { totalPorBuque } = props

  const renderContenidoCard = () => {
    return (
      <>

      </>
    )
  }

  return (
    <>
      {totalPorBuque && totalPorBuque.length > 0 &&
        <Col md={3} style={{ margin: '2% auto 0 auto', width: '98%' }}>
          {/* <TotalPorBuque totalPorBuque={props.totalPorBuque} /> */}
          <CardValores
            titulo={(totalPorBuque.length > 1) ? 'Buques cargando' : 'Buque cargando'}
            cantidad={0}
            contenido={renderContenidoCard()}
            porcentaje={<></>}
            icono={''}
            cardColor='black'
          />
        </Col>
      }
    </>

  )
}

const mapStateToProps = (state) => ({
  totalPorBuque: state.embarque.totalPorBuque
})

const withRedux = connect(mapStateToProps, null)
export default withRedux(ValoresEmbarque)
